export default "__VITE_ASSET__CaBv9Zzv__"